import { render } from "./addCurrency.vue?vue&type=template&id=3058e37b&scoped=true"
import script from "./addCurrency.vue?vue&type=script&lang=js"
export * from "./addCurrency.vue?vue&type=script&lang=js"

import "./addCurrency.vue?vue&type=style&index=0&id=3058e37b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3058e37b"]])

export default __exports__